// Vuex connections module mutations

import {
  FILL_LIST, FILL_PROJECT, UPDATE_LIST_BY_CALLBACK_STEP,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [FILL_PROJECT](state, payload) {
    const _state = state;
    _state.selectedProjectName = payload;
  },
  [UPDATE_LIST_BY_CALLBACK_STEP](state, payload) {
    const _state = state;
    _state.list.records = _state.list.records.map(item => (item.wh1_uuid === payload.connectionUuid
      ? { ...item, callback_status: payload.isCalling ? payload.statusName : 'NOT_CALLED' }
      : item));
  },
};
